var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5833333333333334,0,0,0.5833333333333334,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.07,6.54a.25.25,0,0,0,.27,0,.23.23,0,0,0,.16-.23V1.49A.5.5,0,0,0,20,1H16.5a.5.5,0,0,0-.5.5v.59a.52.52,0,0,0,.14.35Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.72,11.8,12.72.3a1,1,0,0,0-1.44,0L.28,11.8a1,1,0,0,0-.2,1.09,1,1,0,0,0,.92.6H2.5A.5.5,0,0,1,3,14v8.5A1.5,1.5,0,0,0,4.5,24H9a1,1,0,0,0,1-1V19a2,2,0,0,1,4,0v4a1,1,0,0,0,1,1h4.5a1.5,1.5,0,0,0,1.5-1.5V14a.5.5,0,0,1,.5-.5H23a1,1,0,0,0,.92-.6A1,1,0,0,0,23.72,11.8Z",
    style: {
      fill: "current"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.0798a8c83f520ef052401b158defab34.svg";
export { ForwardRef as ReactComponent };